(function () {
  const VISIBLE_CLASS = 'custom-reveal--visible';
  const REVEAL_SELECTOR = '.custom-reveal:not(.custom-reveal--visible)';

  function revealElement(element) {
    element.classList.add(VISIBLE_CLASS);
  }

  function initCustomReveal(root) {
    const scope = root || document;
    const elements = scope.querySelectorAll(REVEAL_SELECTOR);
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(revealElement);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealElement(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -50px 0px', threshold: 0 }
    );

    elements.forEach((element) => observer.observe(element));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomReveal(document));
  } else {
    initCustomReveal(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initCustomReveal(event.target);
  });
})();
